// src/hooks/banks/useCreateBank.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createBank } from "../../api/apiBanks";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateBank = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {
        mutate: createBankAction,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createBank,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/banks');
            queryClient.invalidateQueries({ queryKey: ["banks"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create bank");
        },
    });

    return {
        createBank: createBankAction,
        isPending: isPending || isLoading,
    };
};

export default useCreateBank;
